import { combineReducers } from "redux";

import catalogReducer from "./umbraco/redux/catalog.reducer";
import dictionaryReducer from "components/Dictionary/redux/dictionary.reducer";
import overlayReducer from "layout/redux/overlay.reducer";
import umbracoPageReducer from "./umbraco/redux/page.reducer";
import umbracoSettingsReducer from "./umbraco/redux/settings.reducer";

export const reducer = (): any => combineReducers({
    catalog: catalogReducer,
    dictionary: dictionaryReducer,
    overlay: overlayReducer,
    page: umbracoPageReducer,
    settings: umbracoSettingsReducer
});

export type AppRootState = ReturnType<typeof reducer>;